<template>
  <div id="app">
    <MeteogramsComponent  />
  </div>
</template>

<script>
import MeteogramsComponent from "./MeteogramsComponent";

export default {
  name: 'app',
  components: {
    MeteogramsComponent,
  }
}
</script>
